import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box, Typography, useTheme, Grid2, Skeleton } from "@mui/material";
import { useParams } from "react-router-dom";
import { useGetCostProgressCurveQuery } from "store/slices/apis/costSlice";

const SCurveFinancialProgress = (props) => {
    const { earnValueData } = props
    const theme = useTheme();
    const { projectId } = useParams();
    const [category, setCategory] = useState([]);
    const [actualLineColor, setActualLineColor] = useState(null);
    const [actualData, setActualData] = useState([]);
    const [planData, setPlanData] = useState([]);
    const costProgressRes = useGetCostProgressCurveQuery({ projectId });



    // const categories = [
    //     "Jul,24",
    //     "Aug,24",
    //     "Sep,24",
    //     "Oct,24",
    //     "Nov,24",
    // ];

    useEffect(() => {
        if (costProgressRes?.isSuccess) {
            const actualValue = costProgressRes?.data?.data?.map((item) => item?.actualCumulative > 0 ? item?.actualCumulative : null);
            const planValue = costProgressRes?.data?.data?.map((item) => item?.plannedCumulative > 0 ? item?.plannedCumulative : null);

            const actualTotal = actualValue.reduce((a, b) => a + b, 0);
            const planTotal = planValue.reduce((a, b) => a + b, 0);

            const actualColor = actualTotal >= planTotal ? '#3E756D' : '#E72B33';
            setActualLineColor(actualColor);
            setActualData(actualValue);
            setPlanData(planValue);
            setCategory(costProgressRes?.data?.data?.map((item) => item?.month));

        }
        earnValueData(costProgressRes);
    }, [costProgressRes])

    // Data series for Actual, Plan, and Revised
    // const actualData = [20, 40, 30, 50, 60, 80];
    // const planData = [50, 20, 70, 80, 100, 70];


    // const actualTotal = actualData.reduce((a, b) => a + b, 0);
    // const planTotal = planData.reduce((a, b) => a + b, 0);
    // const actualLineColor = actualTotal >= planTotal ? '#3E756D' : '#CB402D';

    const options = {
        chart: {
            height: 350
        },
        title: {
            text: "",
            align: "left",
            style: { fontSize: "24px", fontWeight: "bold", color: "#223365" },
        },
        xAxis: {
            title: { text: "Months" },
            categories: category,
            tickLength: 10,
            tickWidth: 1,
            tickColor: '#999',
            tickmarkPlacement: 'on',
            lineWidth: 1,
            lineColor: '#758195',
            labels: {
                style: { color: '##414D55', }
            },

        },
        yAxis: {
            title: { text: 'Progress Percentage' },

            labels: {
                style: { color: '#414D55' }
            },
            min: 0,
            tickLength: 10,
            tickWidth: 1,
            tickColor: '#999',
            tickmarkPlacement: 'on',
            gridLineWidth: 1,
            lineWidth: 1,
            lineColor: '#758195'
        },
        tooltip: {
            shared: true,
            useHTML: true,
            backgroundColor: "#00000080",
            shadow: false,
            formatter: function () {
                return ` <b>Actual: ${this.points[1]?.y ?? 0}</b><br/><b>Planned: ${this.points[0]?.y ?? 0}</b>`;
            },
            style: {
                color: '#fff'
            }
        },
        legend: {
            align: "left",
            verticalAlign: "top",
            layout: "horizontal",
            itemDistance: 20,
            useHTML: true,
            symbolWidth: 0,
            x: -10,
            itemMarginBottom: 20,
            labelFormatter: function () {
                return `<span style="display:inline-block;width:13px;height:13px;background-color:${this.color};margin-right:5px;"></span>
              <span style="font-size:15px;font-weight:500;color:#182A4E">${this.name}</span>`;
            }
        },
        plotOptions: {
            series: {
                marker: {
                    enabled: true,
                    symbol: 'circle',
                    states: {
                        hover: {
                            enabled: true,
                            radius: 5
                        }
                    }
                },
                states: {
                    hover: {
                        lineWidthPlus: 0
                    }
                }
            }
        },
        series: [
            {
                name: 'Planned',
                data: planData,
                color: '#295477',
                lineWidth: 2
            },
            {
                name: 'Actual',
                data: actualData,
                color: actualLineColor,
                lineWidth: 2
            },

        ],
        credits: {
            enabled: false,
        },
    };

    return (
        <>
            <Grid2 size={{ xs: 12, md: 12 }} sx={{ p: 2, }}>
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: "500",
                        fontSize: '18px',
                        color: `${theme?.customSettings?.themeColor}`,
                        lineHeight: '100%',
                        letterSpacing: '-0.4px',

                    }}
                >
                    Financial Progress - S Curve
                </Typography>
                <Typography
                    variant="caption"
                    sx={{
                        fontWeight: "400",
                        fontSize: '14px',
                        color: '#182A4E80',
                        lineHeight: '100%',
                        letterSpacing: '-0.4px',


                    }}
                >
                    Planned versus actual financial progress to evaluate cost performance and forecast accuracy
                </Typography>
            </Grid2>
            <Grid2 size={{ md: 12 }}>
                {costProgressRes?.isLoading &&
                    <Box height={400}>
                        <Skeleton variant="rectangular" height={390} animation="wave" sx={{ borderRadius: 7 }} />
                    </Box>
                }
                {!costProgressRes?.isLoading &&
                    <Box sx={{ pl: 1, pr: 1 }} >
                        <HighchartsReact highcharts={Highcharts} options={options} />
                    </Box>
                }

            </Grid2>
        </>
    )
};

export default SCurveFinancialProgress;
